// ur.js — Urdu translation for flatpickr
export const Urdu = {
    weekdays: {
      shorthand: ['ات', 'پ', 'من', 'بد', 'جمع', 'جمعہ', 'ہفتہ'],
      longhand: [
        'اتوار',
        'پیر',
        'منگل',
        'بدھ',
        'جمعرات',
        'جمعہ',
        'ہفتہ',
      ],
    },
    months: {
      shorthand: [
        'جنوری',
        'فروری',
        'مارچ',
        'اپریل',
        'مئی',
        'جون',
        'جولائی',
        'اگست',
        'ستمبر',
        'اکتوبر',
        'نومبر',
        'دسمبر',
      ],
      longhand: [
        'جنوری',
        'فروری',
        'مارچ',
        'اپریل',
        'مئی',
        'جون',
        'جولائی',
        'اگست',
        'ستمبر',
        'اکتوبر',
        'نومبر',
        'دسمبر',
      ],
    },
    firstDayOfWeek: 1,
  };
  